import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.png';
import InfoJumb3 from './images/infoJumbo3.jpg';

import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class MSMarking extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/Zubehoer">Zubehör</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>MS-Marking</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="MS-Marking"/>
        </div>
        <div className="supMainTextLS">
          <h1>MS-Marking</h1>
          <Grid className="supMainInfo">
          <Row>
            <Col xsHidden smHidden md={5}>
              <Carousel  controls={false} interval={3000}>
                <Carousel.Item >
                    <img  src={InfoJumb1}  alt="MS-Marking"  height="100%" />
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb2} alt="MS-Marking"  height="100%"/>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb3} alt="MS-Marking"  height="100%" />
                </Carousel.Item>
              </Carousel>
              </Col>
            <Col xsHidden md={7}>
              <h4>MS-Marking ist Lieferant von Systemen und Technologien zur direkten und dauerhaften Kennzeichnung von Teilen und Komponenten im Produktionsprozess.
Mit Partnern und Herstellern werden komplette Lösungen zum Markieren von Teilen in  automatischen Produktionslinien entwickelt und produziert.
Ein besonderes Highlight sind Tiefenprägungen für die Kennzeichnung von Fahrgestellnummern, welche durch den Einsatz gesteuerter Impulstechnik ermöglicht werden.
            </h4>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden>
              <h4>MS-Marking ist Lieferant von Systemen und Technologien zur direkten und dauerhaften Kennzeichnung von Teilen und Komponenten im Produktionsprozess.
            </h4>
            </Col>
            <Col xs={12} md={{ span: 7, offset: 2 }}>
              <Button className="supMainButtonWebPage" variant="light" href="http://www.ms-marking.de/" target="_blank">Hersteller Homepage</Button>
            </Col>
          </Row>
        </Grid>
      </div>
        <br/>
        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid className="shortDesc">
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Nadelmarkieren</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Ritzmarkieren</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Laserbeschriften</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>tradionelle Markiertechnik</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Tragbare und stationäre Technologien</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Automitiv, Luft- und Raumfahrt, Robotik, Gieserei, Fahrzeigbau, Stahlherstellung</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                <h4>&#9658; &nbsp; Nadelmarkieren</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                  <h4>&#9658; &nbsp; Ritzmarkieren</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h4>&#9658; &nbsp; Laserbeschriften</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h4>&#9658; &nbsp; tradionelle Markiertechnik</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h4>&#9658; &nbsp; Tragbare und stationäre Technologien</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h4>&#9658; &nbsp; Automotiv, Luft- und Raumfahrt, Robotik, Gieserei, Fahrzeigbau, Stahlherstellung</h4>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>

        </div>
    );
  }
}

export default MSMarking;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/msmarking/mainPageSup.js